// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-methods-card {
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  overflow: hidden;
}
.payment-methods-card h5 {
  font-weight: 700;
  color: #1a1a1a;
  font-size: 1.25rem;
}
.payment-methods-card .payment-icon-wrapper {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}
.payment-methods-card .payment-icon-wrapper i {
  color: white !important;
}

.payment-options-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.payment-method-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #ffffff;
}
.payment-method-item.clickable {
  cursor: pointer;
}
.payment-method-item.clickable:hover {
  border-color: #667eea;
  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.15);
  transform: translateY(-2px);
}
.payment-method-item.clickable:active {
  transform: translateY(0);
}
.payment-method-item.selected {
  border-color: #667eea;
  background: linear-gradient(to right, #f8f9ff 0%, #ffffff 100%);
  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.2);
}
.payment-method-item .payment-method-content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex: 1 1;
}
.payment-method-item .payment-radio {
  margin-top: 4px;
}
.payment-method-item .payment-radio .form-check-input {
  cursor: pointer;
  width: 20px;
  height: 20px;
  border: 2px solid #d1d5db;
  transition: all 0.2s ease;
}
.payment-method-item .payment-radio .form-check-input:checked {
  background-color: #667eea;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.payment-method-item .payment-radio .form-check-input:focus {
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}
.payment-method-item .payment-info {
  flex: 1 1;
}
.payment-method-item .payment-logo {
  width: 36px;
  height: 36px;
  object-fit: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}
.payment-method-item .payment-name {
  font-weight: 600;
  color: #1a1a1a;
  font-size: 1rem;
}
.payment-method-item .payment-description {
  font-size: 0.875rem;
  color: #6b7280;
  margin-left: 48px;
}
.payment-method-item .selection-indicator {
  position: absolute;
  top: 12px;
  right: 12px;
}
.payment-method-item .selection-indicator i {
  color: #10b981;
  font-size: 1.5rem;
  animation: scaleIn 0.3s ease;
}
.payment-method-item .badge {
  font-size: 0.75rem;
  padding: 4px 8px;
  font-weight: 600;
  animation: slideIn 0.3s ease;
}

.security-note {
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  border-radius: 10px;
  border: 1px solid #d1fae5;
}
.security-note i {
  font-size: 1.25rem;
}
.security-note small {
  line-height: 1.5;
}
.security-note small strong {
  color: #065f46;
}

@keyframes scaleIn {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes slideIn {
  from {
    transform: translateX(10px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
.new-payment-card {
  border-top: 2px solid green !important;
  border: 2px solid green;
}`, "",{"version":3,"sources":["webpack://./src/pages/Student/PaymentForm/PaymentMethods.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;AACF;AACE;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;AACJ;AAEE;EACE,6DAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+CAAA;AAAJ;AAEI;EACE,uBAAA;AAAN;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;;AAKA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,iDAAA;EACA,mBAAA;AAFF;AAIE;EACE,eAAA;AAFJ;AAII;EACE,qBAAA;EACA,gDAAA;EACA,2BAAA;AAFN;AAKI;EACE,wBAAA;AAHN;AAOE;EACE,qBAAA;EACA,+DAAA;EACA,+CAAA;AALJ;AAQE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,SAAA;AANJ;AASE;EACE,eAAA;AAPJ;AASI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;AAPN;AASM;EACE,yBAAA;EACA,qBAAA;EACA,8CAAA;AAPR;AAUM;EACE,8CAAA;AARR;AAaE;EACE,SAAA;AAXJ;AAcE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iDAAA;AAZJ;AAeE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAbJ;AAgBE;EACE,mBAAA;EACA,cAAA;EACA,iBAAA;AAdJ;AAiBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAfJ;AAiBI;EACE,cAAA;EACA,iBAAA;EACA,4BAAA;AAfN;AAmBE;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;AAjBJ;;AAqBA;EACE,6DAAA;EACA,mBAAA;EACA,yBAAA;AAlBF;AAoBE;EACE,kBAAA;AAlBJ;AAqBE;EACE,gBAAA;AAnBJ;AAqBI;EACE,cAAA;AAnBN;;AAyBA;EACE;IACE,mBAAA;IACA,UAAA;EAtBF;EAwBA;IACE,mBAAA;IACA,UAAA;EAtBF;AACF;AAyBA;EACE;IACE,2BAAA;IACA,UAAA;EAvBF;EAyBA;IACE,wBAAA;IACA,UAAA;EAvBF;AACF;AA2BA;EACE,sCAAA;EACA,uBAAA;AAzBF","sourcesContent":[".payment-methods-card {\n  border: 1px solid #e8e8e8;\n  border-radius: 12px;\n  overflow: hidden;\n\n  h5 {\n    font-weight: 700;\n    color: #1a1a1a;\n    font-size: 1.25rem;\n  }\n\n  .payment-icon-wrapper {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    width: 50px;\n    height: 50px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n\n    i {\n      color: white !important;\n    }\n  }\n}\n\n.payment-options-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.payment-method-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  border: 2px solid #e8e8e8;\n  border-radius: 12px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  background: #ffffff;\n\n  &.clickable {\n    cursor: pointer;\n\n    &:hover {\n      border-color: #667eea;\n      box-shadow: 0 4px 16px rgba(102, 126, 234, 0.15);\n      transform: translateY(-2px);\n    }\n\n    &:active {\n      transform: translateY(0);\n    }\n  }\n\n  &.selected {\n    border-color: #667eea;\n    background: linear-gradient(to right, #f8f9ff 0%, #ffffff 100%);\n    box-shadow: 0 4px 16px rgba(102, 126, 234, 0.2);\n  }\n\n  .payment-method-content {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    flex: 1;\n  }\n\n  .payment-radio {\n    margin-top: 4px;\n\n    .form-check-input {\n      cursor: pointer;\n      width: 20px;\n      height: 20px;\n      border: 2px solid #d1d5db;\n      transition: all 0.2s ease;\n\n      &:checked {\n        background-color: #667eea;\n        border-color: #667eea;\n        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n      }\n\n      &:focus {\n        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);\n      }\n    }\n  }\n\n  .payment-info {\n    flex: 1;\n  }\n\n  .payment-logo {\n    width: 36px;\n    height: 36px;\n    object-fit: contain;\n    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n  }\n\n  .payment-name {\n    font-weight: 600;\n    color: #1a1a1a;\n    font-size: 1rem;\n  }\n\n  .payment-description {\n    font-size: 0.875rem;\n    color: #6b7280;\n    margin-left: 48px;\n  }\n\n  .selection-indicator {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n\n    i {\n      color: #10b981;\n      font-size: 1.5rem;\n      animation: scaleIn 0.3s ease;\n    }\n  }\n\n  .badge {\n    font-size: 0.75rem;\n    padding: 4px 8px;\n    font-weight: 600;\n    animation: slideIn 0.3s ease;\n  }\n}\n\n.security-note {\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);\n  border-radius: 10px;\n  border: 1px solid #d1fae5;\n\n  i {\n    font-size: 1.25rem;\n  }\n\n  small {\n    line-height: 1.5;\n\n    strong {\n      color: #065f46;\n    }\n  }\n}\n\n// Animations\n@keyframes scaleIn {\n  from {\n    transform: scale(0);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n// Remove old styles\n.new-payment-card {\n  border-top: 2px solid green !important;\n  border: 2px solid green;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
